export interface GDSInformation{
    pnrSource: string;
    pnrLocatorNumber: string;
    previousPNRInfo: string;
    willBePNRPending: boolean;
    allowAddingTravelers: boolean;
    resCardXML: string;
}
